// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2Qmqh","footer":"ModalCreateQualiphyProcedure_footer__1ClKt","additionData":"ModalCreateQualiphyProcedure_additionData__3H4hI"};